import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import InputControl from '~/components/Input/InputControl';
import Input from '@material-ui/core/Input';

import { editFilter } from '../../../../store/actions';

function InputString(props) {
  const {
    filter,
    indexGroup,
    indexFilter,
    inputProps,
    ...ownProps
  } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <InputControl
      value={filter.get('value')}
      name={'value'}
      inputComponent={Input}
      InputProps={{
        placeholder: t('filter-label-value'),
        ...inputProps,
      }}
      onChange={({ value }) => dispatch(editFilter(indexGroup, indexFilter, 'value', value))}
      {...ownProps}
    />
  );
}

export default React.memo(InputString);
